"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: ()=>Card
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _useCard = require("./useCard");
const _renderCard = require("./renderCard");
const _useCardStyles = require("./useCardStyles");
const _useCardContextValue = require("./useCardContextValue");
const Card = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCard.useCard_unstable)(props, ref);
    const cardContextValue = (0, _useCardContextValue.useCardContextValue)(state);
    (0, _useCardStyles.useCardStyles_unstable)(state);
    return (0, _renderCard.renderCard_unstable)(state, cardContextValue);
});
Card.displayName = 'Card'; //# sourceMappingURL=Card.js.map

//# sourceMappingURL=Card.js.map